/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";
import { ItemProps } from "../Menu";

export const buttonStyle = css`
	padding: 6px 8px;
	width: 100%;
	justify-content: flex-start;
	text-align: left;
`;

export const menuStyle = (isGroup: boolean, fullWidth: boolean, maxWidth: UnitString) => css`
	padding: 8px;
	width: ${fullWidth ? "100%" : "fit-content"};
	min-width: 160px;
	max-width: ${maxWidth};
	border-radius: ${isGroup ? 0 : "8px"};
	box-sizing: border-box;
	box-shadow: ${isGroup ? "none" : "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.2)"};
`;

export const colorItemStyle = (
	theme: Theme,
	selected: boolean,
	color: string,
	disabled: boolean,
	width: UnitString = "28px",
	radius: UnitString = "12px"
) => css`
	width: ${width};
	height: ${width};
	border-radius: ${radius};
	box-sizing: border-box;
	justify-content: center;
	align-items: center;

	&:hover {
		border-color: ${!disabled ? theme.colors.neutral_80_100 : "none"};
		width: 24px;
		height: 24px;
	}

	border-color: ${selected && !disabled ? theme.colors.neutral_80_100 : theme.colors.neutral_00_100};
`;

export const colorStyle = (theme: Theme, color: string) => css`
	border: 2px solid ${theme.colors.neutral_00_100};
	background: ${color};
`;

export const listStyle = (maxHeight: string) => css`
	font-size: 13px;
	overflow: auto;
	max-height: ${maxHeight};
`;

export const cursorStyle = css`
	cursor: pointer;
`;

export const menuItemStyle = (align: ItemProps["align"]) => css`
	transition: 250ms all cubic-bezier(0.2, 0.8, 0.4, 1);
	display: flex;
	align-items: center;
	justify-content: ${align};
`;

export const linkStyle = css`
	width: 100%;
	list-style: none;
	text-decoration: none;
	color: #000;
`;

export const headerStyle = css`
	padding: 6px 8px;
	font-weight: bold;
	border-bottom: 1px solid #eee;

	.subtitle {
		padding: 5px 0;
	}
`;

export const subTitleStyle = css`
	padding: 6px 8px;
	color: #b3b3b3;
`;

export const textEllipsis = css`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const menuGroupStyle = css`
	border-radius: 8px;
	box-sizing: border-box;
	box-shadow:
		0px 0px 4px rgba(0, 0, 0, 0.04),
		0px 8px 16px rgba(0, 0, 0, 0.2);
	z-index: 10;
	background: #fff;
`;

export const selectedStyle = (theme: Theme) => css`
	[data-selected] {
		button {
			border-color: ${theme.colors.neutral_80_100};
		}
	}
`;

export const descriptionStyle = (theme: Theme) => css`
	padding: 0px 8px;
	color: ${theme.colors.secondary_80_8};
`;
